import { render, staticRenderFns } from "./GalleryForm.vue?vue&type=template&id=1b38cc95&scoped=true&"
import script from "./GalleryForm.vue?vue&type=script&lang=js&"
export * from "./GalleryForm.vue?vue&type=script&lang=js&"
import style0 from "./GalleryForm.vue?vue&type=style&index=0&id=1b38cc95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38cc95",
  null
  
)

export default component.exports